import { Modal, Flex, Checkbox } from "antd";
import { Button } from "@/components/ui/button";
import {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useUserStore } from "@/hooks/useUserStore";
import customerApi from "@/services/customerApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
const privacyContent = {
  title: "美業聯合網 隱私權政策",
  content: [
    {
      title: "第一條",
      subTitle: "本公司透過本服務蒐集以下的使用者個人資料：",
      content: [
        "使用者於美業聯合網留下的電子郵件地址、密碼以及電話號碼。",
        "使用者的個人資料，包括辨識類（如本服務中所呈現之個人姓名、性別、年齡與地址）、特徵類（如體態資訊、膚質、膚況、膚色、頭髮狀況、眼睛顏色、大頭貼照片、訊息等等）、社會情況類（如家鄉、居住城市、居住環境）。",
        "以自動化方式蒐集使用者的Cookies資料、IP位置、裝置資訊（作業系統類型、硬體資訊、裝置識別碼、裝置設定等等）、瀏覽器類型以及瀏覽器語言、匿名的位置資訊，包括但不限於使用者的地理位置以及使用者裝置連接或適用範圍內之WIFI網路。",
      ],
    },
    {
      title: "第二條",
      subTitle:
        "本公司蒐集、處理與利用您個人資料之目的如下：對個人資料的利用方式為以自動化機器或其他非自動化之方式利用。請您留意，本公司可能基於一個或多個目的蒐集、處理與利用您的個人資料，也可能以一種或多種方式蒐集、處理與利用您的個人資料：",
      content: [
        "向您提供本服務：包括帳號註冊與管理、個人資訊頁面的內容管理、使用者驗證與帳號安全、備份存檔、與美容店家等之預約管理。",
        "支付與帳務處理：包含帳務與費用的處理（如聯繫您或第三方進行收款、退款、付款之確認與執行狀況）。",
        "客戶服務：與提供本服務相關的顧客服務，包括客戶意見調查、滿意度調查或評分、客訴處理或客戶支援服務。",
        "遵守法令：預防及調查任何使用者違法或違反使用條款之行為。",
        "行銷廣告：例如寄送通知、電子郵件給您、提供您更好的廣告與直接行銷體驗、推薦更適合您的資訊和活動內容。",
        "發展與改善本服務：發展我們的新服務以及改善我們現有的服務。",
        "市場調查、研究與分析：將您的個人資料用於匯集顧客分析以及市場調查，以升級本服務而提供更好的使用者體驗、了解本服務相關的市場需求、分析使用者的習慣、偏好等。",
      ],
    },
    {
      title: "第三條",
      subTitle:
        "在使用者未同意之情形下，本公司將不會公開使用者個人資料予任何第三方，除非按照以下規定向本公司所委託之第三方公開，或是本公司依據展開業務的特定司法管轄區的法律或規定受要求公開。",
      content: [
        "第三方服務提供商與合作夥伴：若本公司認為有必要，可能與第三方服務提供商與合作夥伴分享以處理與利用從使用者蒐集的個人資料，以達成與本服務使用相關的特定目的，包含用於向您提供本服務、支付與帳務處理、客戶服務、行銷廣告、市場調查、研究與分析。",
        "提供給合作的金融機構：為處理需支付給您或是向您收取的法定貨幣以及相關帳務處理（收付款、退款、帳務核對等），本公司會將您的部分個人資料揭露給合作的金融機構。",
        "提供給專業人士：為了處理您與本公司的糾紛，本公司可能會將您的個人資料揭露給本公司的律師、會計師、記帳士、顧問等專業人士。",
        "當業務轉移時：當本公司有任何併購、出售公司資產、融資之情況時，本公司可能會將您的個人資料轉讓或揭露給另一家公司。於此情形，我們將在業務移轉前以電子郵件或本服務的通知系統通知您。",
        "當本公司受法律規定或限制時：為了遵守適用法律、政府機關命令、法院命令時，我們會在法律或命令的範圍內揭露您的個人資料給法院或其他政府機關，例如回應法院命令或傳票（包括回應政府當局，以滿足國家安全或執法要求）。",
        "為增進公共利益所必要、免除您的生命、身體、自由或財產之危險，或為防止他人權益之重大危害，本公司將會進行調查、預防並可能採取行動。此時，本公司可能會揭露您的個人資料給法院、警察或其他政府機關、第三方金融機構。",
      ],
    },
    {
      title: "第四條",
      subTitle:
        "本公司處理、利用您的個人資料的期間為自蒐集到您的個人資料時起，至有下列情形之一（以最晚發生者為準）時為止：",
      content: [
        "個人資料蒐集之特定目的全部消失或期限屆滿時；",
        "本服務終止時；",
        "有權管轄的政府機關依法令要求本公司停止處理、利用或刪除您的個人資料；或",
        "您書面（包含紙本與電子郵件）要求本公司停止處理、利用或刪除您的個人資料，且依法本公司可以這麼做時。",
      ],
      footer:
        "請特別留意，如果依據所適用的法令本公司有義務保存您的個人資料一定的期間，則停止處理、利用後，本公司仍會在法定期間內保存您的個人資料，並依法拒絕您刪除個人資料的要求。只有在處理、利用期間終止且沒有法定義務規定本公司應繼續保存您的個人資料時，本公司才會刪除您的個人資料或將您的個人資料去識別化。",
    },
    {
      title: "第五條",
      subTitle:
        "本公司將使用自有或是租用的硬碟、伺服器與網路連線設備處理與利用您的個人資料。這些設備目前將會存放在臺灣，但將來存放的位置可能會因為本公司所使用的服務提供商不同而有變動。在此情形下，資料所在地的政府、法院、執法單位或監管機構，可能會依據該地之法律取得您的個人資料。請注意，該資料所在地對於隱私保護的標準可能會低於您所在的法律管轄地的標準；當有此等情形時，我們會使用適當的保護措施來保護所傳輸的個人資料。",
      content: [],
    },
    {
      title: "第六條",
      subTitle:
        "未成年人不得使用本公司所提供的任何服務。因此，本公司將不會有意地蒐集未成年人的個人資料。倘若本公司透過通知或自行了解到其蒐集到來自未成年人的任何個人資料，本公司將會停用此使用者帳號，並採取適當手段從我們的記錄中刪除這些個人資料。然而，因分享任何未成年人個人資料而產生的法律責任，本公司概不負責，此法律責任應全然由分享這些個人資料的人承擔。",
      content: [],
    },
    {
      title: "第七條",
      subTitle:
        "本《隱私權政策》的效力範圍僅及於本服務，若您在本服務中點選第三方網站的連結或廣告，進而進入或將資訊分享於各該第三方時，應依各該第三方所定的隱私權政策規定處理。這些第三方的網站或廣告連結可能設置有追蹤您行為的技術，一旦您點選該等連結後即可能被第三方視為他們的目標受眾，而您的網路使用行為將可被他們追蹤，這些第三方也可能據此提供您該第三方認為您可能感興趣的內容。建議您在瀏覽其他網站與廣告商的網站時，應先仔細閱覽這些第三方網站的隱私權政策。若您因第三方網站取得您的個人資料而遭受或發生任何損失、損害、成本或費用，本公司均不負擔任何責任。請注意本公司對於其他網站與廣告商的隱私權政策、隱私設定、服務與內容均不負擔任何責任，也不保證其安全性或符合您的需求。本公司合作的美業店家等第三方透過本服務以外方式所蒐集、處理與利用個人資料行為，也不適用本《隱私權政策》。",
      content: [],
    },
    {
      title: "第八條",
      subTitle:
        "您可以自行決定是否提供您的個人資料給本公司，但如您不提供，或要求刪除個人資料，本公司可能無法繼續提供本服務給您、您的使用者體驗可能降低，或是將無法使用本服務之完整功能。",
      content: [],
    },
    {
      title: "第九條",
      subTitle:
        "就本公司所蒐集、處理與利用的您的個人資料，您可以依據相關法律以及本《隱私權政策》，行使下列權利。但請注意，本公司受理下列各項請求時，會依據個人資料保護法的規定辦理，且辦理期間可能會延長：",
      content: [
        "查詢或請求閱覽本公司蒐集的個人資料。請注意，本公司對查詢、閱覽將收取必要成本費用。",
        "製給本公司蒐集的個人資料的複製本。請注意，本公司對製給複製本將收取必要成本費用。",
        "補充或更正本公司蒐集的個人資料。本公司針對部分個人資料的欄位開放您自行登入後補充或更正。",
        "請求本公司停止繼續蒐集、處理或利用其已蒐集的個人資料。",
        "刪除本公司蒐集的個人資料。",
      ],
      footer:
        "在某些情形下，例如刪除或停止處理或利用您的個人資料，即表示本公司可能無法繼續向您提供本服務、您的使用者體驗可能降低，或是將無法使用本服務之完整功能。也請特別注意，本公司無法刪除為遵循法律相關義務所須的個人資料，也不能刪除依法令規定必須保留一定年限的個人資料。",
    },
    {
      title: "第十條",
      subTitle:
        "如果您要刪除您的帳號與個人資料，請在登入後，到『個人資訊』的地方，使用『連繫我們』寄出郵件，內容中請詳細陳述您的意圖、註冊的電子郵件地址、以及您的『個人代碼』。『個人代碼』可以在『個人資訊』處中找到。請注意，您的帳號與個人資料刪除後，您之前對我們服務與產品的回饋（定義見本公司的使用條款）還是會保留在本公司，本公司亦無法刪除為遵循法律相關義務所須的個人資料，也不能刪除依法令規定必須保留一定年限的個人資料。",
      content: [],
    },
    {
      title: "第十一條",
      subTitle:
        "本《隱私權政策》可能會不定期變更，如本《隱私權政策》內容有任何變動，本公司將於本服務中通知或是以電子郵件通知您。如果更新後的本《隱私權政策》中有任何您不同意的條款，請立即停止使用本服務，若您於本《隱私權政策》更新後繼續訪問或使用本服務，將視為您同意本公司依據變更後的本《隱私權政策》蒐集、處理與利用您的個人資料。 倘若使用者對於本《隱私權政策》有任何問題、想要行使您的權利，或是就有關於本公司如何處理與利用您的個人資料有任何投訴或意見，請加入官方Line@ https://lin.ee/JpakVoM。為了回應您的問題、需求、投訴或意見，本公司必須先驗證您的真實身分。如您無法或不願意配合驗證身分，請恕本公司可能無法處理您的問題、需求、投訴或意見。",
      content: [],
    },
  ],
};

export const PrivacyPage = ({
  open,
  onCancel,
  onNext,
  onDelete,
  isCancelable = true,
  isDeleteable = false,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [readToBottom, setReadToBottom] = useState(false);
  const contentRef = useRef(null);

  // 監控滾動事件
  const handleScroll = () => {
    if (!contentRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
    // 當滾動到底部或接近底部時（允許5px誤差）
    if (scrollHeight - scrollTop - clientHeight <= 5) {
      setReadToBottom(true);
    }
  };

  useEffect(() => {
    // 重置狀態當彈窗重新打開時
    if (open) {
      setReadToBottom(false);
      setIsChecked(false);

      // 確保DOM已渲染後再滾動到頂部
      setTimeout(() => {
        if (contentRef.current) {
          contentRef.current.scrollTop = 0;
        }
      }, 100);
    }
  }, [open]);

  const handleCancel = () => {
    onCancel();
  };

  // 簡化 handleNext，直接調用傳入的 onNext
  const handleNext = () => {
    onNext(isChecked);
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      className="[&_.ant-modal-content]:!p-0"
      footer={null}
      style={{
        top: 0,
        minWidth: "100vw",
        margin: 0,
        padding: 0,
      }}
      closable={isCancelable}
    >
      <Flex
        vertical
        justify="center"
        align="center"
        className="h-[100svh] w-full gap-4 p-4"
      >
        <h2 className="my-2 text-xl font-bold">{privacyContent.title}</h2>
        <div
          ref={contentRef}
          onScroll={handleScroll}
          className="border-border-50 flex flex-1 flex-col overflow-y-auto rounded-xl border p-4"
        >
          {privacyContent.content.map((item, index) => (
            <div key={index} className="mb-4 text-sm">
              <h3 className="font-bold">{item.title}</h3>
              {item.subTitle && <p>{item.subTitle}</p>}
              {item.content && item.content.length > 0 && (
                <div>
                  {item.content.map((paragraph, pIndex) => (
                    <div key={pIndex} className="flex">
                      <p className="mr-1">{pIndex + 1}.</p>
                      <p>{paragraph}</p>
                    </div>
                  ))}
                  {item.footer && <p>{item.footer}</p>}
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="flex w-full flex-col gap-4">
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            disabled={!readToBottom}
          >
            我已閱讀並同意以上條款
          </Checkbox>
          <Flex justify="center" align="center" className="my-4 gap-4">
            {isCancelable && (
              <Button
                onClick={handleCancel}
                variant="outline"
                size="small"
                className="border-2 border-main p-8 py-1 text-lg text-main hover:text-main/80 active:text-main/80"
              >
                取消
              </Button>
            )}
            {isDeleteable && (
              <Button
                onClick={handleDelete}
                variant="outline"
                size="small"
                className="border-2 border-main p-8 py-1 text-lg text-main hover:text-main/80 active:text-main/80"
              >
                刪除
              </Button>
            )}
            <Button
              onClick={handleNext}
              disabled={!isChecked}
              variant="default"
              size="small"
              className="border-2 border-main p-8 py-1 text-lg text-white"
            >
              下一步
            </Button>
          </Flex>
        </div>
      </Flex>
    </Modal>
  );
};

// 隱私頁控制組件
export const PrivacyControl = forwardRef(({ mode = "default" }, ref) => {
  const navigate = useNavigate();
  const userStore = useUserStore();
  const { profile } = userStore;
  const queryClient = useQueryClient();
  const [privacyOpen, setPrivacyOpen] = useState(mode === "register");

  const { data: privacyNotes, isLoading } = useQuery({
    queryKey: ["privacyNotes"],
    queryFn: () => customerApi.getUserNotes("privacy_page"),
    enabled: !!profile, // 只有當profile存在時才執行查詢
  });

  // 使用useMutation創建privacy_page筆記
  const { mutate: createPrivacyNote } = useMutation({
    mutationFn: (noteData) => customerApi.createUserNote(noteData),
    onSuccess: () => {
      // 創建成功後更新查詢
      queryClient.invalidateQueries({ queryKey: ["privacyNotes"] });
      // 關閉隱私頁
      setPrivacyOpen(false);
    },
    onError: (error) => {
      console.error("創建隱私頁筆記失敗:", error);
    },
  });

  const { mutate: deletePrivacyNote } = useMutation({
    mutationFn: (noteId) => customerApi.deleteUserNote(noteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["privacyNotes"] });
      // 刪除後顯示隱私頁
      setPrivacyOpen(true);
    },
    onError: (error) => {
      console.error("刪除隱私頁筆記失敗:", error);
    },
  });

  // 暴露方法給父組件
  useImperativeHandle(ref, () => ({
    // 打開隱私頁方法
    openPrivacyPage: () => {
      setPrivacyOpen(true);
    },
    // 執行 createPrivacyNote 方法，包含刷新用戶資料
    executeOnNext: async () => {
      console.log("executeOnNext被調用");
      try {
        createPrivacyNote({
          name: "privacy_page",
          value: "agreed",
        });
      } catch (error) {
        console.error("創建隱私筆記時發生錯誤:", error);
        return false;
      }
    },
    // 檢查隱私頁是否已同意
    checkPrivacyAgreed: () => {
      return privacyNotes && privacyNotes.length > 0;
    },
    // 刪除現有的隱私筆記
    deletePrivacyNotes: () => {
      if (privacyNotes && privacyNotes.length > 0) {
        // 刪除每一個隱私筆記
        privacyNotes.forEach((note) => {
          deletePrivacyNote(note.id);
        });
        return true;
      }
      return false;
    },
  }));

  useEffect(() => {
    // 當獲取到筆記數據後，檢查是否有privacy_page筆記
    if (profile && !isLoading) {
      // 如果privacyNotes不存在或為空數組，則顯示PrivacyPage
      if (!privacyNotes || privacyNotes.length === 0) {
        setPrivacyOpen(true);
      } else {
        setPrivacyOpen(false);
      }
    }
  }, [profile, privacyNotes, isLoading]);

  const handleCancel = () => {
    // 根據不同模式處理邏輯
    switch (mode) {
      case "register":
      case "thirdParty":
        navigate("/login");
        break;
      default:
        setPrivacyOpen(false);
        break;
    }
  };

  // 在 PrivacyControl 中直接處理不同模式的邏輯
  const handleNext = (isChecked) => {
    if (!isChecked) return;

    // 根據不同模式處理邏輯
    switch (mode) {
      case "register":
        // 註冊模式：僅關閉彈窗，後續通過executeOnNext手動觸發創建筆記
        console.log(
          "註冊模式：關閉隱私頁面，等待完成註冊後手動調用executeOnNext",
        );
        setPrivacyOpen(false);
        break;
      case "thirdParty":
      default:
        console.log("createPrivacyNote");

        // 預設模式：創建隱私政策同意筆記
        if (profile) {
          createPrivacyNote({
            name: "privacy_page",
            value: "agreed",
          });
        } else {
          console.error("無法創建隱私筆記：用戶資料不存在");
        }
        break;
    }
  };

  // 處理刪除操作
  const handleDeleteNotes = () => {
    if (privacyNotes && privacyNotes.length > 0) {
      // 刪除每一個隱私筆記
      privacyNotes.forEach((note) => {
        deletePrivacyNote(note.id);
      });
    }
  };

  const isDebug = false;
  return (
    <PrivacyPage
      open={isDebug ? true : privacyOpen}
      onCancel={handleCancel}
      onNext={handleNext}
      onDelete={handleDeleteNotes}
      isCancelable={mode === "default" ? false : true}
      isDeleteable={isDebug ? true : false}
    />
  );
});
